import { useState } from 'react';

import clsxm from '@/lib/clsxm';

import Link, { LinkVariant } from '@/components/link';
import Select from '@/components/select';
import Typography from '@/components/typography';

import {
  BackgroundColor,
  backgroundColorToColorNameMap,
} from '@/enums/background-color';
import useFaqPageContext from '@/features/faq-page/hooks/use-faq-page-context';
import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';
import RegionsService, { Region } from '@/services/regions.service';
import { routes } from '@/utils/route-utils';

type SearchSpecialtyJobsByLocationCTAProps = {
  id: string;
};

export default function SearchSpecialtyJobsByLocationCTA({
  id,
}: SearchSpecialtyJobsByLocationCTAProps) {
  const { specialty, specialtyPageStaticData } = useSpecialtyPageContext();
  const { faqPageStaticData } = useFaqPageContext();
  const states =
    specialtyPageStaticData?.ctas[id]?.regions ||
    faqPageStaticData?.regions ||
    [];
  const [selectedOption, setSelectedOption] = useState<Region>();

  return (
    <div
      className={clsxm(
        'flex w-full flex-col items-center justify-between text-center',
        'gap-6 rounded-3xl p-6 md:px-12',
        backgroundColorToColorNameMap[BackgroundColor.LIGHT_BLUE]
      )}
    >
      <Typography.Heading5>
        Find your next travel nurse destination
      </Typography.Heading5>

      <div
        className={clsxm(
          'flex w-full flex-col items-center gap-2',
          'md:p-2 lg:max-w-md lg:flex-row lg:rounded-full lg:bg-white'
        )}
      >
        <Select
          name='state'
          label='STATE'
          labelKey='name'
          valueKey='id'
          uniqueKey='id'
          selectedOptions={selectedOption}
          onSelect={(option) => setSelectedOption(option as Region)}
          options={states}
          className='m-0 min-h-full w-full border-none py-0 shadow-none focus:ring-0'
          rounded
        />
        <Link
          href={routes.jobSearch({
            discipline: specialty?.discipline?.apiId || undefined,
            specialty: specialty?.title,
            locations: selectedOption?.name ? [selectedOption?.name] : [],
          })}
          variant={LinkVariant.PRIMARY_BUTTON}
          className='whitespace-nowrap sm:w-full lg:w-auto'
        >
          Search Jobs
        </Link>
      </div>
    </div>
  );
}

export async function getStaticProps() {
  const states = RegionsService.get().then((res) =>
    res.map(({ id, name }) => ({ key: id, label: name, value: name }))
  );

  return {
    props: {
      states,
    },
  };
}
